"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveGlassmorphicLibraryImage = exports.GLASSMORPHIC_LIBRARY_IMAGES = void 0;
const DEFAULT_MARKETING_IMAGE_BASE_URL = 'https://glonextrack.com';
exports.GLASSMORPHIC_LIBRARY_IMAGES = {
    operations: {
        src: '/images/marketing/section-deep-dive-feature-explanation-glassmorphic.jpg',
        alt: 'glassmorphic telematics operations illustration',
    },
    modules: {
        src: '/images/marketing/section-sub-functions-feature-modules-glassmorphic.jpg',
        alt: 'glassmorphic telematics modules illustration',
    },
    capabilities: {
        src: '/images/marketing/section-capabilities-key-capabilities-glassmorphic.jpg',
        alt: 'glassmorphic key capabilities illustration',
    },
    risk: {
        src: '/images/marketing/section-case-study-customer-impact-glassmorphic.jpg',
        alt: 'glassmorphic insurance and risk analytics illustration',
    },
    growth: {
        src: '/images/marketing/section-cta-conversion-glassmorphic.jpg',
        alt: 'glassmorphic growth and conversion illustration',
    },
};
const GLASSMORPHIC_KEYWORD_RULES = [
    {
        key: 'risk',
        keywords: [
            'insurance',
            'ubi',
            'underwriting',
            'claims',
            'actuarial',
            'risk',
            'policy',
        ],
    },
    {
        key: 'modules',
        keywords: [
            'device',
            'iot',
            'ota',
            'firmware',
            'sensor',
            'camera',
            'tracker',
            'telematics unit',
        ],
    },
    {
        key: 'capabilities',
        keywords: [
            'analytics',
            'report',
            'kpi',
            'compliance',
            'governance',
            'performance',
            'farmer',
            'farming',
            'agri',
            'agriculture',
            'livestock',
            'crop',
        ],
    },
    {
        key: 'growth',
        keywords: [
            'pricing',
            'billing',
            'subscription',
            'revenue',
            'growth',
            'roi',
            'conversion',
            'retention',
        ],
    },
];
const normalizeText = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
const toAbsoluteImageUrl = (path, baseUrl) => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    const base = (baseUrl || DEFAULT_MARKETING_IMAGE_BASE_URL).replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${base}${normalizedPath}`;
};
const resolveGlassmorphicLibraryImage = (params) => {
    const searchableText = normalizeText([
        params.title ?? '',
        params.category ?? '',
        params.primaryKeyword ?? '',
        ...(params.secondaryKeywords ?? []),
        ...(params.tagHints ?? []),
    ].join(' '));
    for (const rule of GLASSMORPHIC_KEYWORD_RULES) {
        if (rule.keywords.some((keyword) => searchableText.includes(normalizeText(keyword)))) {
            const selected = exports.GLASSMORPHIC_LIBRARY_IMAGES[rule.key];
            return {
                ...selected,
                src: toAbsoluteImageUrl(selected.src, params.baseUrl),
            };
        }
    }
    const fallback = exports.GLASSMORPHIC_LIBRARY_IMAGES.operations;
    return {
        ...fallback,
        src: toAbsoluteImageUrl(fallback.src, params.baseUrl),
    };
};
exports.resolveGlassmorphicLibraryImage = resolveGlassmorphicLibraryImage;
